export const enLMSMarketplace = {
  hero: {
    title: "LMS and Online Course Marketplace Platform",
    subtitle: "Comprehensive learning management system with integrated course marketplace capabilities.",
    imageAlt: "LMS platform interface showing course dashboard"
  },
  features: {
    courseMarketplace: {
      title: "Course Marketplace",
      description: "Integrated platform for course creators to sell and learners to discover quality content."
    },
    contentFormats: {
      title: "Multiple Content Formats",
      description: "Support for videos, live sessions, text, SCORM packages, and articles."
    },
    monetization: {
      title: "Flexible Monetization",
      description: "Subscriptions, one-time payments, installment options, and coupon support."
    },
    userRoles: {
      title: "Multi-tier User Roles",
      description: "Admin, instructors, organizations, and students with appropriate permissions."
    },
    learningTools: {
      title: "Advanced Learning Tools",
      description: "Scheduling, content dripping, quizzes, certificates, forums, and support tickets."
    },
    customization: {
      title: "Complete Customization",
      description: "Themes, drag-and-drop UI, multilingual support, RTL, and white-labeling."
    }
  },
  techStack: {
    title: "Technology Stack",
    backend: {
      title: "Backend",
      laravel: "Laravel PHP framework for robust operations",
      api: "API-first architecture for integrations",
      compliance: "SCORM and xAPI compliant"
    },
    frontend: {
      title: "Frontend",
      framework: "Vue.js with interactive components",
      design: "Tailwind CSS for modern UI",
      typescript: "TypeScript for type safety"
    },
    integrations: {
      title: "Integrations",
      payments: "Stripe, PayPal payment gateways",
      video: "Vimeo, YouTube, Zoom integration",
      analytics: "Learning analytics and reporting"
    }
  },
  dashboard: {
    title: "Powerful Learning Dashboard",
    description: "Complete control over your educational platform with comprehensive analytics and management tools.",
    demoAlt: "LMS platform admin dashboard preview",
    features: {
      "1": "Integrated course marketplace",
      "2": "Multiple content delivery formats",
      "3": "Flexible monetization options",
      "4": "Advanced user role management",
      "5": "Real-time learning analytics"
    }
  },
  cta: {
    title: "Ready to Launch Your Learning Platform?",
    description: "Discover how our LMS and Marketplace solution can transform your educational offerings.",
    buttonText: "View Demo",
    buttonAriaLabel: "View demo of the LMS platform"
  }
};

export const frLMSMarketplace = {
  hero: {
    title: "Plateforme LMS et Marketplace de Cours en Ligne",
    subtitle: "Système complet de gestion de l'apprentissage avec des capacités de marketplace de cours intégrées.",
    imageAlt: "Interface de la plateforme LMS montrant le tableau de bord des cours"
  },
  features: {
    courseMarketplace: {
      title: "Marketplace de Cours",
      description: "Plateforme intégrée pour les créateurs de cours pour vendre et les apprenants pour découvrir du contenu de qualité."
    },
    contentFormats: {
      title: "Formats de Contenu Multiples",
      description: "Support pour les vidéos, les sessions en direct, le texte, les packages SCORM et les articles."
    },
    monetization: {
      title: "Monétisation Flexible",
      description: "Abonnements, paiements uniques, options de paiement échelonné et support des coupons."
    },
    userRoles: {
      title: "Rôles Utilisateurs Multi-niveaux",
      description: "Admin, instructeurs, organisations et étudiants avec les autorisations appropriées."
    },
    learningTools: {
      title: "Outils d'Apprentissage Avancés",
      description: "Planification, diffusion de contenu, quiz, certificats, forums et tickets de support."
    },
    customization: {
      title: "Personnalisation Complète",
      description: "Thèmes, interface utilisateur glisser-déposer, support multilingue, RTL et marque blanche."
    }
  },
  techStack: {
    title: "Technologie Stack",
    backend: {
      title: "Backend",
      laravel: "Framework Laravel PHP pour des opérations robustes",
      api: "Architecture axée sur l'API pour les intégrations",
      compliance: "Conformité SCORM et xAPI"
    },
    frontend: {
      title: "Frontend",
      framework: "Vue.js avec composants interactifs",
      design: "Tailwind CSS pour une interface utilisateur moderne",
      typescript: "TypeScript pour la sécurité des types"
    },
    integrations: {
      title: "Intégrations",
      payments: "Passerelles de paiement Stripe, PayPal",
      video: "Intégration Vimeo, YouTube, Zoom",
      analytics: "Analytique et reporting d'apprentissage"
    }
  },
  dashboard: {
    title: "Tableau de Bord d'Apprentissage Puissant",
    description: "Contrôle total de votre plateforme éducative avec des outils d'analyse et de gestion complets.",
    demoAlt: "Aperçu du tableau de bord administrateur de la plateforme LMS",
    features: {
      "1": "Marketplace de cours intégré",
      "2": "Formats de livraison de contenu multiples",
      "3": "Options de monétisation flexibles",
      "4": "Gestion avancée des rôles utilisateurs",
      "5": "Analytique d'apprentissage en temps réel"
    }
  },
  cta: {
    title: "Prêt à Lancer Votre Plateforme d'Apprentissage?",
    description: "Découvrez comment notre solution LMS et Marketplace peut transformer vos offres éducatives.",
    buttonText: "Voir la Démo",
    buttonAriaLabel: "Voir la démo de la plateforme LMS"
  }
};

export const nlLMSMarketplace = {
  hero: {
    title: "LMS en Online Cursus Marketplace Platform",
    subtitle: "Uitgebreid leerbeheersysteem met geïntegreerde cursus marketplace mogelijkheden.",
    imageAlt: "LMS platform interface toont cursusdashboard"
  },
  features: {
    courseMarketplace: {
      title: "Cursus Marketplace",
      description: "Geïntegreerd platform voor cursusmakers om te verkopen en voor cursisten om kwalitatieve content te ontdekken."
    },
    contentFormats: {
      title: "Meerdere Contentformaten",
      description: "Ondersteuning voor video's, live sessies, tekst, SCORM-pakketten en artikelen."
    },
    monetization: {
      title: "Flexibele Monetisatie",
      description: "Abonnementen, eenmalige betalingen, gespreide betaling en couponondersteuning."
    },
    userRoles: {
      title: "Multi-tier Gebruikersrollen",
      description: "Admin, instructeurs, organisaties en studenten met passende rechten."
    },
    learningTools: {
      title: "Geavanceerde Leertools",
      description: "Planning, content dripping, quizzen, certificaten, forums en supporttickets."
    },
    customization: {
      title: "Volledige Aanpasbaarheid",
      description: "Thema's, drag-and-drop UI, meertalige ondersteuning, RTL en white-labeling."
    }
  },
  techStack: {
    title: "Technologiestack",
    backend: {
      title: "Backend",
      laravel: "Laravel PHP framework voor robuuste operaties",
      api: "API-first architectuur voor integraties",
      compliance: "SCORM- en xAPI-compatibel"
    },
    frontend: {
      title: "Frontend",
      framework: "Vue.js met interactieve componenten",
      design: "Tailwind CSS voor moderne UI",
      typescript: "TypeScript voor typeveiligheid"
    },
    integrations: {
      title: "Integraties",
      payments: "Stripe, PayPal betaalgateways",
      video: "Vimeo, YouTube, Zoom integratie",
      analytics: "Leeranalytics en rapportage"
    }
  },
  dashboard: {
    title: "Krachtig Leer Dashboard",
    description: "Volledige controle over uw educatieve platform met uitgebreide analytics en beheertools.",
    demoAlt: "Preview van LMS platform admin dashboard",
    features: {
      "1": "Geïntegreerde cursus marketplace",
      "2": "Meerdere content delivery-formaten",
      "3": "Flexibele monetisatieopties",
      "4": "Geavanceerd gebruikersrollenbeheer",
      "5": "Realtime leeranalytics"
    }
  },
  cta: {
    title: "Klaar om uw leerplatform te lanceren?",
    description: "Ontdek hoe onze LMS en Marketplace oplossing uw educatieve aanbod kan transformeren.",
    buttonText: "Bekijk Demo",
    buttonAriaLabel: "Bekijk demo van het LMS platform"
  }
};

export const deLMSMarketplace = {
  hero: {
    title: "LMS und Online-Kurs-Marktplatz-Plattform",
    subtitle: "Umfassendes Lernmanagementsystem mit integrierten Kursmarktplatz-Funktionen.",
    imageAlt: "LMS-Plattform-Oberfläche zeigt Kurs-Dashboard"
  },
  features: {
    courseMarketplace: {
      title: "Kurs-Marktplatz",
      description: "Integrierte Plattform für Kursanbieter zum Verkauf und Lernende zur Entdeckung hochwertiger Inhalte."
    },
    contentFormats: {
      title: "Mehrere Inhaltsformate",
      description: "Unterstützung für Videos, Live-Sessions, Text, SCORM-Pakete und Artikel."
    },
    monetization: {
      title: "Flexible Monetarisierung",
      description: "Abonnements, Einmalzahlungen, Ratenzahlungsoptionen und Gutscheinunterstützung."
    },
    userRoles: {
      title: "Mehrstufige Benutzerrollen",
      description: "Admin, Dozenten, Organisationen und Studierende mit entsprechenden Berechtigungen."
    },
    learningTools: {
      title: "Erweiterte Lernwerkzeuge",
      description: "Planung, Content Dripping, Quizze, Zertifikate, Foren und Support-Tickets."
    },
    customization: {
      title: "Komplette Anpassung",
      description: "Themes, Drag-and-Drop-UI, Mehrsprachigkeit, RTL und White-Labeling."
    }
  },
  techStack: {
    title: "Technologie-Stack",
    backend: {
      title: "Backend",
      laravel: "Laravel PHP Framework für robuste Abläufe",
      api: "API-First-Architektur für Integrationen",
      compliance: "SCORM- und xAPI-konform"
    },
    frontend: {
      title: "Frontend",
      framework: "Vue.js mit interaktiven Komponenten",
      design: "Tailwind CSS für modernes UI",
      typescript: "TypeScript für Typsicherheit"
    },
    integrations: {
      title: "Integrationen",
      payments: "Stripe, PayPal Zahlungs-Gateways",
      video: "Vimeo, YouTube, Zoom Integration",
      analytics: "Lernanalyse und Reporting"
    }
  },
  dashboard: {
    title: "Leistungsstarkes Lern-Dashboard",
    description: "Vollständige Kontrolle über Ihre Bildungsplattform mit umfassenden Analyse- und Verwaltungstools.",
    demoAlt: "Vorschau des LMS-Plattform-Admin-Dashboards",
    features: {
      "1": "Integrierter Kurs-Marktplatz",
      "2": "Mehrere Content-Delivery-Formate",
      "3": "Flexible Monetarisierungsoptionen",
      "4": "Erweitertes Benutzerrollenmanagement",
      "5": "Echtzeit-Lernanalyse"
    }
  },
  cta: {
    title: "Bereit, Ihre Lernplattform zu starten?",
    description: "Erfahren Sie, wie unsere LMS- und Marketplace-Lösung Ihr Bildungsangebot transformieren kann.",
    buttonText: "Demo ansehen",
    buttonAriaLabel: "Demo der LMS-Plattform ansehen"
  }
};